import type { Weapon } from "./weapon";
import { Solidifier } from "./weapons/solidifier";
import { TripleSolidifier } from "./weapons/tripleSolidifier";
import { Cannon } from "./weapons/cannon";
import { CannonBurst } from "./weapons/cannonBurst";
import { DrillLauncher } from "./weapons/drillLauncher";
import { MissileGun } from "./weapons/missileGun";
import { MissileBurst } from "./weapons/missileBurst";
import { PlasmaGun } from "./weapons/plasmaGun";
import { LandmineWeapon } from "./weapons/landmineWeapon";
import { BarrierGun } from "./weapons/barrierGun";
import { Flamethrower } from "./weapons/flamethrower";
import { LaserGun } from "./weapons/laserGun";
import { GasBombWeapon } from "./weapons/gasBombWeapon";
import { OpGun } from "./weapons/opGun";
import { OpGun2 } from "./weapons/opGun2";
import { OpGunNuke } from "./weapons/opGunNuke";
import { DevGunAutoKill } from "./weapons/devGunAutoKill";
import { DebugRemoteControl } from "./weapons/debugRemoteControl";
import { RockGun } from "./weapons/rockGun";
import { AirBlast } from "./weapons/airBlast";
import { CryoGun } from "./weapons/cryoGun";
import { Jetpack } from "./weapons/jetpack";
import { Sword } from "./weapons/sword";
import { Cleaver } from "./weapons/cleaver";
import { BlackHoleGun } from "./weapons/blackHoleGun";

type WeaponClass = abstract new (...args: any[]) => Weapon;

export interface WeaponFamilyConfig {
	familyId: number;
	weaponClasses: WeaponClass[];
}

export const WEAPON_FAMILIES: WeaponFamilyConfig[] = [
	{ familyId: 1, weaponClasses: [Solidifier, TripleSolidifier, AirBlast, CryoGun, Sword, Cleaver] },
	{ familyId: 2, weaponClasses: [Cannon, CannonBurst, DrillLauncher] },
	{ familyId: 3, weaponClasses: [MissileGun, MissileBurst, PlasmaGun] },
	{ familyId: 4, weaponClasses: [LandmineWeapon, BarrierGun] },
	{ familyId: 5, weaponClasses: [Flamethrower, LaserGun] },
	{ familyId: 6, weaponClasses: [GasBombWeapon] },
	{ familyId: 7, weaponClasses: [Jetpack] },
	{
		familyId: 0,
		weaponClasses: [OpGun, OpGun2, BlackHoleGun, OpGunNuke, DevGunAutoKill, DebugRemoteControl, RockGun],
	},
];

const classToFamilyId = new Map<WeaponClass, number>();
const classToOrderIndex = new Map<WeaponClass, number>();

for (const family of WEAPON_FAMILIES) {
	for (let i = 0; i < family.weaponClasses.length; i++) {
		const cls = family.weaponClasses[i];
		classToFamilyId.set(cls, family.familyId);
		classToOrderIndex.set(cls, i);
	}
}

export function getFamilyForWeapon(weapon: Weapon): number {
	return classToFamilyId.get(weapon.constructor as WeaponClass) ?? 7;
}

export function getOrderInFamily(weapon: Weapon): number {
	return classToOrderIndex.get(weapon.constructor as WeaponClass) ?? Infinity;
}
